<img src="./assets/images/paymentError.png" alt="Stripe" style="max-width: 20%"/>
<p>Sorry. But you have some payment error</p>
